import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
  Widget,
  Table,
  Col,
  Row,
  FormSwitch,
  FormSubmitButton,
  FormatText,
  FormDatePicker,
  FormSelect,
  MasterDetailForm,
  FormTextArea,
  Button,
  Form,
  FormInput,
  FormResetButton,
} from '@digital/ui';
import { compareText } from '@app/helpers/comparators';
import { Collapse, Icon } from 'antd';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

import {
  UsuarioSubstitutoModel,
  updateDadosUsuarioSubstitutoContratos,
  VerificarPerfilLogado,
} from '@app/api/RegraSubstituto';

import { getAllGestoresOptions, getAreasResponsavel, getDiretoriasResponsavel } from '@app/api/usuario';
import { getContratoOptionsForSelectPorGestor } from '@app/api/contrato';

import ButtonAprovar from './buttonAprovar';
import ModalRejeitar from './modalRejeitar';
import ButtonExcluir from './buttonExcluir';
import ModalListaAlteracoes from '../modalListaAlteracoes';

export interface propsUsuarioSubstituto {
  updatePage: any;
  DadosRegrasSubstituicao: UsuarioSubstitutoModel;
  PerfilLogado: VerificarPerfilLogado;
}

const RegrasSubstituicao = (props: propsUsuarioSubstituto) => {
  const { updatePage, DadosRegrasSubstituicao, PerfilLogado } = props;
  const [contratosOptions, setContratosOptions] = useState([]);
  const [gestoresOptions, setGestoresOptions] = useState([]);
  const [diretoriasResponsavel, setDiretoriasResponsavel] = useState([]);
  const [areasResponsavel, setAreasResponsavel] = useState([]);
  const [gestorResponsavelId, setGestorResponsavelId] = useState('');
  const [selectContrato, setSelectContrato] = useState([]);
  const { Panel } = Collapse;

  const onUpdate = () => {
    updatePage();
  };

  const [ehTemporariaContratos, setEhTemporariaContratos] = useState(false);
  const submitSubstitutoContratos = (values: any) =>
    updateDadosUsuarioSubstitutoContratos(values).then(data => {
      onUpdate();
    });

  const initialValues = {
    temporaria: false,
  };

  useEffect(() => {
    getDiretoriasResponsavel().then((data: any) => setDiretoriasResponsavel(data));
    getAreasResponsavel().then((data: any) => setAreasResponsavel(data));
    getAllGestoresOptions().then((data: any) => setGestoresOptions(data));
  }, []);

  useEffect(() => {
    setSelectContrato([]);
    if (gestorResponsavelId !== '') {
      getContratoOptionsForSelectPorGestor(gestorResponsavelId).then((data: any) => setContratosOptions(data));
    }
  }, [gestorResponsavelId]);

  useEffect(() => {}, [diretoriasResponsavel]);

  useEffect(() => {}, [areasResponsavel]);

  const columnPendentes = [
    {
      title: 'Usuário Original',
      dataIndex: 'usuarioOriginal',
      sorter: (a: any, b: any) => compareText(a.usuarioOriginal, b.usuarioOriginal),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Usuário Original"
              name="usuarioOriginal"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.usuarioOriginal &&
        record.usuarioOriginal
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Usuário Substituto',
      dataIndex: 'usuarioSubstituto',
      sorter: (a: any, b: any) => compareText(a.usuarioSubstituto, b.usuarioSubstituto),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Usuário Substituto"
              name="usuarioSubstituto"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.usuarioSubstituto &&
        record.usuarioSubstituto
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Temporária',
      dataIndex: 'temporaria',
      render: (text: any, record: any) => (record.temporaria ? 'Sim' : 'Não'),
    },
    {
      title: 'Data Inicial',
      dataIndex: 'dataInicial',
      render: (text: any, record: any) =>
        record.dataInicial ? moment(record.dataInicial).format(dateTimeFormat) : null,
      sorter: (a: any, b: any) => compareText(a.dataInicial, b.dataInicial),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data Inicial"
              name="dataInicial"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.dataInicial &&
        record.dataInicial
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Data Final',
      dataIndex: 'dataFinal',
      render: (text: any, record: any) => (record.dataFinal ? moment(record.dataFinal).format(dateTimeFormat) : null),
      sorter: (a: any, b: any) => compareText(a.dataFinal, b.dataFinal),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data Final"
              name="dataFinal"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.dataFinal &&
        record.dataFinal
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Contrato',
      dataIndex: 'contratoDescricao',
      sorter: (a: any, b: any) => compareText(a.contratoDescricao, b.contratoDescricao),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Contrato"
              name="contratoDescricao"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.contratoDescricao &&
        record.contratoDescricao
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Diretoria',
      dataIndex: 'diretoriaNome',
      sorter: (a: any, b: any) => compareText(a.diretoriaNome, b.diretoriaNome),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Diretoria"
              name="diretoriaNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.diretoriaNome &&
        record.diretoriaNome
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Área',
      dataIndex: 'areaNome',
      sorter: (a: any, b: any) => compareText(a.areaNome, b.areaNome),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Área"
              name="areaNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.areaNome &&
        record.areaNome
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Justificativa para Substituição',
      dataIndex: 'justificativaSubstituicao',
    },
    {
      title: 'Aprovador / Data',
      dataIndex: 'aprovador',
      render: (text: any, record: any) =>
        record.dataAprovacao
          ? (record.aprovador || '-') + ' - ' + moment(record.dataAprovacao).format(dateTimeFormat)
          : null,
    },
    {
      title: 'Usuário Solicitante',
      dataIndex: 'usuarioSolicitante',
      render: (text: any, record: any) =>
        record.dataSolicitacao
          ? record.usuarioSolicitante + ' - ' + moment(record.dataSolicitacao).format(dateTimeFormat)
          : null,
      sorter: (a: any, b: any) => compareText(a.usuarioSolicitante, b.usuarioSolicitante),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Usuário Solicitante"
              name="usuarioSolicitante"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.usuarioSolicitante &&
        record.usuarioSolicitante
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'status',
      dataIndex: 'statusNome',
      sorter: (a: any, b: any) => compareText(a.statusNome, b.statusNome),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar status"
              name="statusNome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: (filtered: any) => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value: any, record: any) =>
        record.statusNome &&
        record.statusNome
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
  ];

  const columnProcessadas = [
    {
      title: 'Data Proc 01',
      dataIndex: 'dataProcessamentoInicial',
      render: (text: any, record: any) =>
        record.dataProcessamentoInicial ? moment(record.dataProcessamentoInicial).format(dateTimeFormat) : null,
    },
    {
      title: 'Data Proc 02',
      dataIndex: 'dataProcessamentoFinal',
      render: (text: any, record: any) =>
        record.dataProcessamentoFinal ? moment(record.dataProcessamentoFinal).format(dateTimeFormat) : null,
    },
    {
      title: 'Ações',
      render: (text: any, record: any) => {
        if (record.statusCodigo == 1) {
          return (
            <>
              {((areasResponsavel.length > 0 && areasResponsavel.some(obj => obj === record.areaId)) ||
                (diretoriasResponsavel.length > 0 &&
                  diretoriasResponsavel.some(obj => obj === record.diretoriaId))) && (
                <ButtonAprovar regraId={record.id} updatePage={updatePage} />
              )}
              {((areasResponsavel.length > 0 && areasResponsavel.some(obj => obj === record.areaId)) ||
                (diretoriasResponsavel.length > 0 &&
                  diretoriasResponsavel.some(obj => obj === record.diretoriaId))) && (
                <ModalRejeitar regraId={record.id} updatePage={updatePage} />
              )}
              {<ModalListaAlteracoes id={record.id} />}
            </>
          );
        }

        return <>{<ModalListaAlteracoes id={record.id} />}</>;
      },
    },
  ];

  const columnRejeitadas = [
    {
      title: 'Motivo Rejeição',
      dataIndex: 'motivoRejeicao',
    },
    {
      title: 'Ações',
      render: (text: any, record: any) => (
        <>
          {((areasResponsavel.length > 0 && areasResponsavel.some(obj => obj === record.areaId)) ||
            (diretoriasResponsavel.length > 0 && diretoriasResponsavel.some(obj => obj === record.diretoriaId))) && (
            <ButtonExcluir regraId={record.id} updatePage={updatePage} />
          )}
          {<ModalListaAlteracoes id={record.id} />}
        </>
      ),
    },
  ];

  const pendentesColumn = [...columnPendentes, ...columnProcessadas];
  const rejeitadasColumn = [...columnPendentes, ...columnRejeitadas];

  return (
    <>
      {PerfilLogado.perfilTemPermissaoCadastrarUsuarioSubstituto === true ? (
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="cadastroContratos" header="Cadastro de regra de substituição de gestor de contratos">
            <MasterDetailForm
              onSubmit={submitSubstitutoContratos}
              initialValues={initialValues}
              validationSchema={Yup.object().shape({
                contratos: Yup.array().required('É necessário escolher um ou mais contratos.'),
                temporaria: Yup.boolean(),
                usuarioOriginal: Yup.string().required('Gestor Original deve ser informado'),
                usuarioSubstituto: Yup.string()
                  .required('Gestor Substituto deve ser informado')
                  .notOneOf([Yup.ref('usuarioOriginal')], 'Gestor Substituto não pode ser igual ao Gestor Original'),
                dataInicial: Yup.string().required('Data Inicial é obrigatória'),
                dataFinal: Yup.mixed()
                  .when('temporaria', {
                    is: true,
                    then: Yup.date().required('Data Final é obrigatória'),
                  })
                  .test('is_less', 'A data Final não pode ser menor ou igual a inicial', function(value) {
                    if (value) {
                      const { dataInicial } = this.parent;
                      return !moment(value).isSameOrBefore(dataInicial, 'day');
                    }
                    return true;
                  }),
                justificativaSubstituicao: Yup.string().required('A justificativa é obrigatória'),
              })}>
              <Widget
                actions={[
                  <FormSubmitButton noIcon={true} type="primary">
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>,
                ]}>
                <FormSelect
                  label="Usuário Gestor Original"
                  name="usuarioOriginal"
                  span={3}
                  required
                  options={gestoresOptions}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input: any, item: any) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .startsWith(input.toLowerCase());
                  }}
                  onSelect={(value: any) => setGestorResponsavelId(value)}
                />
                <FormSelect
                  label="Usuario Gestor Substituto"
                  name="usuarioSubstituto"
                  span={3}
                  required
                  options={gestoresOptions}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input: any, item: any) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .startsWith(input.toLowerCase());
                  }}
                />
                <FormDatePicker format="DD/MM/YYYY" label="Data Inicial" name="dataInicial" span={2} />
                <FormDatePicker
                  format="DD/MM/YYYY"
                  label="Data Final"
                  name="dataFinal"
                  span={2}
                  disabled={!ehTemporariaContratos}
                  required={ehTemporariaContratos === true ? ehTemporariaContratos : false}
                />
                <FormSwitch
                  label="Temporária"
                  name="temporaria"
                  span={2}
                  onClick={value => {
                    setEhTemporariaContratos(!ehTemporariaContratos);
                  }}
                />
                <FormTextArea label="Justificativa" name="justificativaSubstituicao" rows={1} span={6} />
                <FormSelect
                  label="Contratos"
                  name="contratos"
                  mode="multiple"
                  options={contratosOptions}
                  span={6}
                  filterOption={(input: any, item: any) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  value={selectContrato}
                  onChange={(value: any) => setSelectContrato(value)}
                />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
      ) : (
        <></>
      )}

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="pendentes" header="Substituições para gestor de contratos">
          <Widget>
            <Row>
              <Col>
                <Table columns={pendentesColumn} rowKey="id" dataSource={DadosRegrasSubstituicao.regrasGeral || []} />
              </Col>
            </Row>
          </Widget>
        </Panel>
      </Collapse>

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="rejeitadas" header="Substituições rejeitadas">
          <Widget>
            <Row>
              <Col>
                <Table
                  columns={rejeitadasColumn}
                  rowKey="id"
                  dataSource={DadosRegrasSubstituicao.regrasRejeitadas || []}
                />
              </Col>
            </Row>
          </Widget>
        </Panel>
      </Collapse>
    </>
  );
};

export default RegrasSubstituicao;
